import axios from "axios";
import { API_URL } from "./apiURL";

export async function getSearchResult(reportType,formData) {
  //console.log("Inside API call for getSearchResult for : " + reportType);
  let searchResult = null;
  await axios
    .post(API_URL + "getSearchResult/" + reportType, formData)
    .then((response) => {
      searchResult = response.data;
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });

  return searchResult;
}

export async function getCdeDetails(reportType,crfId){
  //console.log("Inside API call for getCdeDetails for : " + crfId);
  let searchResult = null;
  await axios
    .post(API_URL + "getSearchResult/CdeDetails/" + reportType + "/", { crfId })
    .then((response) => {
      searchResult = response.data;
    })
    .catch((error) => {
      console.error("There was an error!", error);;
    });

    return searchResult;
}

export async function getCrfListing(){
  //console.log("Inside API call for getCrfListing");
  let searchResult = null;
  await axios
    .post(API_URL + "getSearchResult/CrfListing/")
    .then((response) => {
      searchResult = response.data;
    })
    .catch((error) => {
      console.error("There was an error!", error);;
    });

    return searchResult;
}

export async function getNocReport(crfId){
  //console.log("Inside API call for getNocReport for : " + crfId);
  let searchResult = null;
  await axios
    .get(API_URL + "getSearchResult/NocReport/" + crfId)
    .then((response) => {
      searchResult = response.data;
    })
    .catch((error) => {
      console.error("There was an error!", error);;
    });

    return searchResult;
}